module.exports = {"collapseAll":"一键折叠","expandAll":"一键展开","backToPrevious":"返回上一级","getMenuFailed":"获取菜单失败","noMenuPermission":"当前坐席无菜单权限"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales/zh-CN/menu.json
// module id = 7Xr4
// module chunks = 1